import { useParams } from "react-router";
import BResourcePage from "../../../components/resources/BResourcePage";

const UserPropertyPage = () => {
  const params = useParams();

  return <BResourcePage title={"Immobilien"} url={`/Customers/${params.id}/properties`} />;
}

export default UserPropertyPage;